import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6974ac6c1beda800143931bc/webseo_pro/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6974ac6c1beda800143931bc/webseo_pro/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6974ac6c1beda800143931bc/webseo_pro/src/components/ui/AppIcon.tsx");
